import { makeAutoObservable, reaction } from "mobx";

export enum HomeFeature {
  TrendChart,
  AutomationRecommendation,
  TableEquipment,
}

const visibleItemInit = [
  HomeFeature.TrendChart,
]

export class homeFeatureVisibilityStore {
  visibleItem: HomeFeature[] = visibleItemInit
  
  constructor() {
    makeAutoObservable(this)
    reaction(() => this.visibleItem, (visibleItem) => console.log(visibleItem))
  }

  toggleVisibleItem = (item: number) => {
    const indexOfMatchItem = this.visibleItem.indexOf(item)

    if (indexOfMatchItem > -1) {
      this.visibleItem.splice(indexOfMatchItem, 1)
      return
    }
    if (indexOfMatchItem === -1) {
      this.visibleItem.push(item)
      return
    }
  }
}